import { createContext } from 'react'
import { appRoutes } from './routes/routes'
import type { useInternalAppNavigation } from './useInternalNavigation'

export const InternalNavigationContext = createContext({
  location: { state: 'error', key: 'none', ...window.location },
  appLocation: undefined,
  history: [],
  routes: appRoutes,
  navigate: () => {
    throw new Error('No context loaded')
  },
  inView: () => {
    throw new Error('No context loaded')
  },
} as ReturnType<typeof useInternalAppNavigation>)
InternalNavigationContext.displayName = 'Navigation Context'
